import { render, staticRenderFns } from "./buyout-grant-approvals.vue?vue&type=template&id=6a995881&scoped=true&"
import script from "./buyout-grant-approvals.vue?vue&type=script&lang=js&"
export * from "./buyout-grant-approvals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a995881",
  null
  
)

export default component.exports